import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from "@angular/forms";
import { ApiService } from "src/app/services/api.service";
import { Task } from "src/app/models/task";
import { NgxMaterialTimepickerComponent, NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { first, tap } from "rxjs/operators";
import { Moment } from "moment";
import { GanttStatic } from "dhtmlx-gantt";
import { StatutOperOfPipe } from "../lightbox-op/StatutOperOfPipe";
import { MatButton } from "@angular/material/button";
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from "@angular/material/datepicker";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";

@Component({
    selector: "app-lightbox-of",
    templateUrl: "./lightbox-of.component.html",
    styleUrls: ["./lightbox-of.component.scss"],
    standalone: true,
    imports: [
        MatDialogTitle,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatCheckbox,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatSuffix,
        MatDatepicker,
        NgxMaterialTimepickerModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        StatutOperOfPipe,
        MatLabel
    ],
})
export class LightboxOfComponent implements OnInit {
  instance: any;
  instanceForm: UntypedFormGroup = this.fb.group({
    Article: new UntypedFormControl({ value: null, disabled: true }),
    DescCourteArticle: new UntypedFormControl({ value: null, disabled: true }),
    QteLancee: new UntypedFormControl({ value: null, disabled: true }),
    DateDebutTot: new UntypedFormControl({ value: null, disabled: true }),
    DateFinTard: new UntypedFormControl({ value: null, disabled: true }),
    StatutOf: new UntypedFormControl({ value: null, disabled: true }),
    TypeOrigine: new UntypedFormControl({ value: null, disabled: true }),
    NumClient: new UntypedFormControl({ value: null, disabled: true }),
    NumCdeCli: new UntypedFormControl({ value: null, disabled: true }),
    NumeroCde: new UntypedFormControl({ value: null, disabled: true }),
    Priorite: new UntypedFormControl({ value: null}),
    NonJalonnable: new UntypedFormControl({ value: null }),
    Interrompu: new UntypedFormControl({ value: null }),
    ConsignesFab: new UntypedFormControl({ value: null, disabled: true }),
    DateDebutJalon: new UntypedFormControl({ value: null, disabled: true }),
    DateFinJalon: new UntypedFormControl({ value: null, disabled: true }),
    Ratio: new UntypedFormControl({ value: true, disabled: false }),
    DateDebutPrev: new UntypedFormControl({ value: null, disabled: true }),
    RegleJalon: new UntypedFormControl({ value: null, disabled: true }),
  });
  constructor(
    public dialogRef: MatDialogRef<LightboxOfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { task: Task; gantt: GanttStatic },
    private fb: UntypedFormBuilder,
    private apiService: ApiService
  ) {}
  @ViewChild("timeDebutJalon", { static: true })
  timeDebutJalon: NgxMaterialTimepickerComponent;
  @ViewChild("timeFinJalon", { static: true })
  timeFinJalon: NgxMaterialTimepickerComponent;
  ngOnInit() {
    this.apiService
      .generateHttpRequest(
        null,
        "OrdreFabrication/GetEntete/" + this.data.task.SeqOf,
        null,
        "GET",
        null
      )
      .pipe(
        first(),
        tap(() => {
          const startTime =
            this.data.task.start_date.getHours().toString() +
            ":" +
            this.data.task.start_date.getMinutes().toString();
          this.timeDebutJalon.updateTime(startTime);
          const endTime =
            this.data.task.end_date.getHours().toString() +
            ":" +
            this.data.task.end_date.getMinutes().toString();
          this.timeFinJalon.updateTime(endTime);
          this.timeDebutJalon.timeChanged.subscribe((time) => {
            this.data.task.start_date = this.updateDate(
              this.data.task.start_date,
              time
            );
            this.applyRatio("start");
          });
          this.timeFinJalon.timeChanged.subscribe((time) => {
            this.data.task.end_date = this.updateDate(
              this.data.task.end_date,
              time
            );
            this.applyRatio("end");
          });
        })
      )
      .subscribe((result) => {
        this.instance = result;
        this.instanceForm.patchValue(this.instance);
        this.instanceForm
          .get("NonJalonnable")
          ?.patchValue(this.data.task.NonJalonnable);
        this.instanceForm
          .get("RegleJalon")
          ?.patchValue(this.regleJalon(this.instance.RegleJalon));
          this.instanceForm
          .get("Priorite")
          ?.patchValue(this.data.task.Priorite);
          this.instanceForm
          .get("Interrompu")
          ?.patchValue(this.data.task.Interrompu);


      });
  }
  /** L'of n'est pas modifiable si le statut est lancé , en cours ou si il est non jalonnable */
  isMovable() {
    return (
      this.instanceForm.get("StatutOf").value !== "L" &&
      this.instanceForm.get("StatutOf").value !== "E" &&
      this.instanceForm.get("NonJalonnable").value !== true
    );
  }
  regleJalon(regle) {
    return regle === 1
      ? "Au plus tôt"
      : regle === 2
      ? "Au plus tard"
      : "Aucune";
  }
  /**
   * Maintient du ratio
   * @param endOrStart
   * @param difference
   */
  applyRatio(endOrStart) {
    if (this.instanceForm.get("Ratio").value) {
      /** Si ratio préservé alors on met à jour la date de fin en conséquence */
      if (endOrStart === "start") {
        // const momentDate = moment(this.data.task.start_date);
        // momentDate.add(difference, "ms");
        // this.data.task.end_date = momentDate.toDate();
        /** On utilise calculateEndDate afin de recalculer la date de fin en tenant compte des jours chomés */
        this.data.task.end_date = this.data.gantt.calculateEndDate(
          this.data.task
        );

        const endTime =
          this.data.task.end_date.getHours().toString() +
          ":" +
          this.data.task.end_date.getMinutes().toString();
        this.timeFinJalon.updateTime(endTime);
      } else if (endOrStart === "end") {
        // const momentDate = moment(this.data.task.end_date);
        // momentDate.add(-difference, "ms");
        // this.data.task.start_date = momentDate.toDate();
        this.data.task.start_date = this.data.gantt.calculateEndDate({
          start_date: this.data.task.end_date,
          duration: -this.data.task.duration,
        });
        const startTime =
          this.data.task.start_date.getHours().toString() +
          ":" +
          this.data.task.start_date.getMinutes().toString();
        this.timeDebutJalon.updateTime(startTime);
      }
    }
  }
  /**
   * Mise à jour de la date si hh:mm ont été changés
   * @param date
   * @param time
   * @returns
   */
  updateDate(date, time: string) {
    const timeSplitted = time.split(":", 2);
    const finalDate = new Date(date);
    finalDate.setHours(Number(timeSplitted[0]));
    finalDate.setMinutes(Number(timeSplitted[1]));

    return finalDate;
  }
  updateTask(propertyName) {
    this.data.task[propertyName] = this.instanceForm.get(propertyName)?.value;
  }
  /**
   * Si la date input a étée modifiée manuellement
   * @param endOrStart
   * @param event
   * @param ratio
   */
  dateHasChanged(endOrStart, event: any, ratio) {
    const date_start = this.data.task.start_date;
    const date_end = this.data.task.end_date;
    const momentToDate = (event.value as Moment).toDate();
    if (endOrStart === "start") {
      const hours = this.data.task.start_date.getHours();
      const minutes = this.data.task.start_date.getMinutes();
      this.data.task.start_date = momentToDate;
      this.data.task.start_date.setHours(hours);
      this.data.task.start_date.setMinutes(minutes);
      /** Si ratio préservé alors on met à jour la date de fin en conséquence */
      if (ratio) {
        /** On utilise calculateEndDate afin de recalculer la date de fin en tenant compte des jours chomés */
        this.data.task.end_date = this.data.gantt.calculateEndDate(
          this.data.task
        );
        const endTime =
          this.data.task.end_date.getHours().toString() +
          ":" +
          this.data.task.end_date.getMinutes().toString();
        this.timeFinJalon.updateTime(endTime);
      }
    } else if (endOrStart === "end") {
      const hours = this.data.task.end_date.getHours();
      const minutes = this.data.task.end_date.getMinutes();
      this.data.task.end_date = momentToDate;
      this.data.task.end_date.setHours(hours);
      this.data.task.end_date.setMinutes(minutes);
      /** Si ratio préservé alors on met à jour la date de fin en conséquence */
      if (ratio) {
        this.data.task.start_date = this.data.gantt.calculateEndDate({
          start_date: this.data.task.end_date,
          duration: -this.data.task.duration,
        });

        const startTime =
          this.data.task.start_date.getHours().toString() +
          ":" +
          this.data.task.start_date.getMinutes().toString();
        this.timeDebutJalon.updateTime(startTime);
      }
    }
    if (this.data.task.start_date >= this.data.task.end_date) {
      alert("la date de début ne peut être supérieure à la date de fin");
      this.data.task.start_date = date_start;
      this.data.task.end_date = date_end;
    }
  }
  close() {
    if (this.data.task.start_date >= this.data.task.end_date) {
      alert("la date de début ne peut être supérieure à la date de fin");
    } else this.dialogRef.close(this.data.task);
  }
}
